import { render } from "./SettingsIconWhite.vue?vue&type=template&id=3186dc6e"
import script from "./SettingsIconWhite.vue?vue&type=script&lang=js"
export * from "./SettingsIconWhite.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__